import styled from "styled-components";

export const CardContainer = styled.div`
  background-color: var(--primary-white);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 300px;
  min-width: 0;
  height: ${({ showKPIs }) => (showKPIs ? "300px" : "240px")};
  box-sizing: border-box;
  gap: 7px;

  transition: transform 0.3s ease-in-out;
  cursor: ${({ isPopupPreview }) => (isPopupPreview ? "pointer" : "default")};

  &:hover {
    transform: ${({ isPopupPreview }) => (isPopupPreview ? "scale(1.02)" : "none")};
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  min-height: 220px;
  height: 220px;
  background-color: var(--primary-dark-50);
  border-radius: 6px;
  overflow: hidden;
  margin: 0 auto;
`;

export const BookmarkIconWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background: var(--primary-dark-100);
  border-radius: 4px;
  padding: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--primary-dark-100);
  }
`;

export const CardImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const CardVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Metrics = styled.div`
  display: flex;
  gap: 5px;
`;

export const Metric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 90px;
  padding: 8px 10px;
  border-radius: 5px;
  background: var(--primary-dark-50);
  font-size: var(--fs-sm);
  color: var(--primary-dark-300);
  box-sizing: border-box;
  box-shadow: none;

  span {
    display: block;
    font-weight: 500;
    color: var(--primary-black);
    font-size: var(--fs-base);
    margin-top: 2px;
  }
`;

export const ActionButton = styled.button`
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    opacity: 0.9;
  }
`;
